<template>
<v-layout row wrap>
  <v-flex md12>
    <Header />
  </v-flex>

  <v-flex md12>
    <v-list>
      <draggable v-model="queue_completed_pd" :options="{disable:false,draggable:'.item',group:'lists'}" class="minhgt" @end="updateAppointmentPosition" id="completed" :move="onMove">

        <div v-for="queuecompleted in queue_completed_pd" class="item">
          <PatientCompleted
            :name="queuecompleted.name"
            :gender="queuecompleted.gender"
            :age="queuecompleted.age"
            :city="queuecompleted.place"
            :lastVisit="queuecompleted.previous_appointment"
            :id="queuecompleted.id"
            :order="queuecompleted.order"
            :print="queuecompleted.print"
            :person_id="queuecompleted.person_id"
            :billing="queuecompleted.billing"
            :vitals="queuecompleted.vitals"
            :image="queuecompleted.image_new"
            :selectPatient="QueuePatientProfile"
           />
        </div>
      </draggable>

    </v-list>
  </v-flex>
  <v-dialog max-width="800px" v-model="dialogProfileVisible" :lock-scroll="true" :scrollable="true" >
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogProfileVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ViewProfile :manageProfile="!dialogProfileVisible" :selectedPatients="selectedPatient"></ViewProfile>
    </v-card>
  </v-flex xs12>
</v-dialog>
</v-layout>
</template>
<script>
import $ from 'jquery';
import PatientCompleted from './PatientCompleted.vue';
import draggable from 'vuedraggable';
import { mapState, mapActions, mapMutations } from 'vuex';
import ViewProfile from './viewProfile';

// import WaitingList from './WaitingList'

export default {
  name: 'PatientList',
  components: {
    PatientCompleted,
    draggable,
    ViewProfile
    // WaitingList
  },
  data() {
    return {
      // result:[],
      dialogProfileVisible: false
    };
  },
  computed: {
    queue_completed_pd: {
      get() {
        return this.$store.state.queue_completed_pd;
      },
      set(value) {
        this.$store.commit('update_completed_list', value);
      }
    }
  },

  methods: {
    ...mapActions(['getdata', 'changeAppointmentPosition']),
    ...mapMutations(['onEnd']),
    QueuePatientProfile(id) {
      const Patients = this.queue_completed_pd.filter(
        data => data.person_id === id
      );
      this.selectedPatient = Patients[0];
      this.dialogProfileVisible = true;
    },
    onMove(evt) {
      // const eventIdArray = ev.to.id.split("-");
      // const eventToId = eventIdArray[eventIdArray.length - 1];
      // if (eventToId == "completed" || eventToId == "waiting") {
      //   return true
      // }
      //   // return false
      // // } else {
      //   return false
      //   // return true
      // // }
    },
    updateAppointmentPosition(ev) {
      console.log('ev');
      console.log(ev);
      let payload = {};
      const eventIdArray = ev.to.id.split('-');
      const eventToId = eventIdArray[eventIdArray.length - 1];

      if (ev.from.id == ev.to.id) {
        if (ev.oldIndex == ev.newIndex) {
          return;
        }

        // If you drag and drop a element at the end of list then you have to send the previous element's order
        if (this.queue_completed_pd.length == ev.newIndex + 1) {
          payload.order = this.queue_completed_pd[ev.newIndex - 1].order;
        } else if (ev.oldIndex == 0 && ev.newIndex == 1) {
          // If you drag and drop the first element to second element then you have send 0th element's order
          payload.order = this.queue_completed_pd[0].order;
        } else {
          // If you drag and drop a new element into an empty list send order as 1
          // else if(ev.oldIndex === null && ev.newIndex === 1){
          //   payload.order = 1
          // }

          //  Otherwise you have to send the next element's order
          let o = ev.newIndex > ev.oldIndex ? ev.newIndex - 1 : ev.newIndex + 1;
          payload.order = this.queue_completed_pd[o].order;
        }

        payload.qid = this.queue_completed_pd[ev.newIndex].id;
        payload.state = null;
        this.$store.dispatch('updateQue', payload);
      } else {
        payload.state = 1;

        payload.order = 1;
        payload.qid = this.$store.state.Waiting_list_pd[ev.newIndex].id;
        // switch (payload.state) {
        //   case 1:
        //     console.log(
        //       this.$store.state.queue_patient_details[eventToId].info.length
        //     );
        //     if (
        //       this.$store.state.queue_patient_details[eventToId].info.length ==
        //       1
        //     ) {
        //       payload.order = 0;
        //     } else {
        //       payload.order =
        //         this.$store.state.queue_patient_details[eventToId].info[
        //           ev.newIndex + 1
        //         ].order || 0;
        //     }
        //     payload.qid = this.$store.state.queue_patient_details[
        //       eventToId
        //     ].info[ev.newIndex].id;
        //     break;
        //   case 2:{
        //     payload.order = 0;
        //     const hasOrder = this.$store.state.queue_completed_pd[
        //       ev.newIndex + 1
        //     ] && 'order' in this.$store.state.queue_completed_pd[
        //       ev.newIndex + 1
        //     ]
        //     if(hasOrder){
        //     payload.order = this.$store.state.queue_completed_pd[
        //       ev.newIndex + 1
        //     ].order;
        //     }

        //     payload.qid = this.$store.state.queue_completed_pd[ev.newIndex].id;
        //     }
        // }
        this.$store.dispatch('updateQue', payload);
      }
    }
  },
  beforeMount() {
    this.getdata();
  }
};
</script>
<style scoped>
.item {
  border-bottom: 0.5px solid #e0e0e0;
  padding: 0.5rem 0rem;
}

.patient_details {
  display: flex;
  justify-content: space-around;
}

.minhgt {
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/CompletedList.vue